import React from "react";

const Download = (props) => {
    const { color } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="100%" viewBox="0 0 24 24" width="100%" fill={color ? color : "#000000"}>
            <g>
                <rect fill="none" height="24" width="24" />
            </g>
            <g>
                <path d="M5,20h14v-2H5V20z M19,9h-4V3H9v6H5l7,7L19,9z" />
            </g>
        </svg>
    );
};

export default Download;
